import { createContext } from "react";

export type PopoverId =
    | "goals-board-popover"
    | "key-insights-popover"
    | "remind-coach-to-call-client-popover"
    | "coach-assistant-v1-popover"
    | "plan-info-faq-popover";

export const initialPopoverContext = {
    arePopoversInitialized: false,
    popoverIdsShown: new Set<PopoverId>(),
    markPopoverAsShown: (
        _popoverId: PopoverId,
        _temporary: boolean = false,
    ) => {},
};

export const PopoverContext = createContext(initialPopoverContext);
